import styled from "styled-components";

export const MarketFlowerWrapper = styled.div`
  overflow: hidden;
`;

export const MarketFlowerListContainer = styled.section`
  padding: 16px;
`;

export const MarketFlowersList = styled.ul`
  display: grid;
  grid-template-rows: repeat(3, 104px, 128px;);
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 8px;
`;

export const MarketFlowerItem = styled.li`
  margin: 0 auto;
  img {
    border-radius: 8px;
    width: 104px;
    height: 104px;
    cursor: pointer;
  }

  p {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const MarketFlowerItemPreview = styled.div`
  background-color: #000000;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;

  button {
    position: absolute;
    right: 40px;
    top: 40px;
    border: none;
    background: none;
    cursor: pointer;

    img {
      width: 24px;
      height: 24px;
    }
  }

  img {
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  }
`;
